import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

export const enum ImageCalibrationStatus {
  CALIBRATE = 'calibrate',
  CALIBRATING = 'calibrating',
  CALIBRATED = 'calibrated',
}

export const enum RecipeGenerationStatus {
  DEFAULT = 'default',
  GENERATE = 'generate',
  GENERATING = 'generating',
  GENERATED = 'generated',
}

interface SessionState {
  imageCalibrationStatus: Record<string | number, ImageCalibrationStatus>
  galleryImageLodaingMap: Record<string | number, boolean>
  draggableContainerMountRef: boolean
  recipeGenerationStatus: RecipeGenerationStatus
  currentCaseId: string | null
}

const initialState: SessionState = {
  imageCalibrationStatus: {},
  galleryImageLodaingMap: {},
  draggableContainerMountRef: false,
  recipeGenerationStatus: RecipeGenerationStatus.DEFAULT,
  currentCaseId: null,
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setImageCalibrationStatus: (state, action) => {
      const { id, status } = action.payload
      state.imageCalibrationStatus[id] = status
    },

    setGalleryImageLodaingMap: (
      state,
      action: PayloadAction<Record<string | number, boolean>>,
    ) => {
      state.galleryImageLodaingMap = action.payload
    },
    setDraggableContainerMountRef: (state, action: PayloadAction<boolean>) => {
      state.draggableContainerMountRef = action.payload
    },
    setRecipeGenerationStatus: (
      state,
      action: PayloadAction<RecipeGenerationStatus>,
    ) => {
      state.recipeGenerationStatus = action.payload
    },
    setCurrentCaseId(state, action: PayloadAction<string>) {
      state.currentCaseId = action.payload
    },
  },
})

export const {
  setImageCalibrationStatus,
  setGalleryImageLodaingMap,
  setDraggableContainerMountRef,
  setRecipeGenerationStatus,
  setCurrentCaseId,
} = sessionSlice.actions

export default sessionSlice.reducer
